import { InputAdornment, Pagination, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FiFilter, FiGitBranch, FiSearch } from "react-icons/fi";
import {
  LIST_MY_CONTROLLER_TABLE_HEAD,
  statusValue,
} from "../../variables/constants";
import {
  Button,
  Card,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Option,
  Select,
  Typography,
} from "@material-tailwind/react";
import { GrLocation } from "react-icons/gr";
import { FaRegSquareCheck } from "react-icons/fa6";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { getServices } from "../../apiServices/apiServices";
import { FaRegDotCircle } from "react-icons/fa";
import NoDataFound from "../../components/NoDataFound";
import LoadingGif from "../../assets/loading_anim.gif";
import { LuPencil } from "react-icons/lu";

function AdminController() {
  const [loading, setLoading] = useState(false);
  const [myControllerList, setMyControllerList] = useState({});
  const { page_nmr } = useParams();
  const navigate = useNavigate();
  const access_token = localStorage.getItem("gassol-admin-token");

  useEffect(() => {
    fetchMyControllerList();
  }, [page_nmr]);

  const fetchMyControllerList = async () => {
    setLoading(true);

    try {
      const res = await getServices(
        `/api/hardware/list?page=${page_nmr}&limit=10`,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        setMyControllerList(res.responseData);
      } else {
        setMyControllerList({});
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleHardareSearch = async (value) => {
    if (value.length > 0) {
      try {
        const res = await getServices(
          `/api/hardware/list?searchkey=${value}`,
          access_token
        );
        if (res.responseCode === 200) {
          setMyControllerList(res.responseData);
        } else {
          setMyControllerList({});
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      fetchMyControllerList();
    }
  };

  const handleOpenControllerUpdate = (controller_data) => {
    // navigate("/admin/admin_dashboard", {
    //   state: { controller_data: controller_data, isUpdate: true },
    // });
    navigate("/admin/update_controller", {
      state: { controller_data: controller_data },
    });
  };

  const handlePaginationChange = (e, page) => {
    navigate(`/admin/admin_controller/${page}`);
  };

  return (
    <>
      <div className="px-6 pb-5 flex flex-col gap-8 pt-4 lg:pt-0">
        <p className="text-5xl font-bold text-black">Controllers</p>
        {/* <div className="flex justify-between flex-col md:flex-row md:items-center gap-5">
          <div className="flex items-center gap-2 font-semibold">
            <FiFilter className="text-xl" />
            <p>Filter</p>
          </div>
          <div>
            <Select variant="standard" label="Select Version">
              {statusValue.map((item, i) => (
                <Option key={i} style={{ fontFamily: "Poppins" }}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </div>

          <div>
            <TextField
              id="input-with-icon-textfield"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <GrLocation />
                  </InputAdornment>
                ),
              }}
              variant="standard"
              placeholder="Location"
              sx={{
                ".MuiInput-root::after": {
                  borderBottom: "2px solid #03438D !important",
                },
                ".MuiInput-root": {
                  fontFamily: "Poppins",
                },
                width: "100%",
              }}
            />
          </div>
          <div>
            <TextField
              id="input-with-icon-textfield"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FiGitBranch />
                  </InputAdornment>
                ),
              }}
              variant="standard"
              placeholder="Branch"
              sx={{
                ".MuiInput-root::after": {
                  borderBottom: "2px solid #03438D !important",
                },
                ".MuiInput-root": {
                  fontFamily: "Poppins",
                },
                width: "100%",
              }}
            />
          </div>
          <div className="relative flex md:block justify-end">
            <Button className="bg-[#03438D] font-poppins pr-10 py-[14px]">
              Go
            </Button>
            <button
              type="button"
              className="bg-[#BDBDBD] capitalize rotate-90 rounded-full font-poppins font-normal px-2 py-1 -right-3 top-[10.5px] text-xs text-white"
              style={{ position: "absolute" }}
            >
              Clear
            </button>
          </div>
        </div> */}

        <div className="flex flex-col md:flex-row justify-between md:items-center gap-4 md:gap-0">
          <div className="relative">
            <input
              type="text"
              className="py-4 pl-12 pr-4 outline-none rounded-xl w-full md:min-w-[280px] xl:min-w-[350px]"
              placeholder="Search by Hardware ID/Branch"
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
              onChange={(e) => {
                // const numericValue = e.target.value
                //   .replace(/[^0-9]/g, "")
                //   .slice(0, 16);
                // handleHardareSearch(numericValue);
                handleHardareSearch(e.target.value);
              }}
              // maxLength={16}
              // onKeyDown={(e) => {
              //   if (
              //     e.key === "e" ||
              //     e.key === "E" ||
              //     e.key === "-" ||
              //     e.key === "+"
              //   ) {
              //     e.preventDefault();
              //   }
              // }}
              // onWheel={(e) => e.target.blur()}
            />
            <FiSearch className="absolute top-5 left-4 text-[#BDBDBD]" />
          </div>

          {/* <div className="flex items-center gap-3 justify-end">
            <Button className="font-poppins bg-[#BDBDBD] font-medium text-xs sm:text-sm xl:text-base rounded-xl px-4 sm:px-6">
              Download Report
            </Button>
            <Button
              onClick={handleControllerModal}
              className="font-poppins bg-[#BD3B24] font-medium text-xs sm:text-sm xl:text-base rounded-xl flex items-center gap-2 px-4 sm:px-6"
            >
              <LuPlusCircle />
              Add Controller
            </Button>
          </div> */}
        </div>

        {!loading ? (
          <div>
            {myControllerList.data?.length > 0 ? (
              <Card
                className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
                style={{
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
                }}
              >
                <table className="w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {LIST_MY_CONTROLLER_TABLE_HEAD.map((head) => (
                        <th
                          key={head}
                          className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-poppins text-white font-semibold uppercase"
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {myControllerList?.data?.map((controller, index) => {
                      return (
                        <tr key={index}>
                          <td className="p-4">
                            <Link
                              to={`/admin/admin_controller_details`}
                              state={{
                                hardware_id: controller.hardware_id,
                                controller_data: controller,
                              }}
                              className="font-poppins font-semibold flex items-center gap-2 text-sm text-black"
                            >
                              <FaRegSquareCheck className="text-lg text-[#BD3B24]" />
                              {controller.hardware_id ?? "-"}
                            </Link>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {controller.company_name ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {controller.branch ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`flex items-center gap-1 font-poppins font-medium text-xs w-fit px-4 py-1 rounded-lg ${
                                controller.running_status === 1
                                  ? "text-yellow-600 bg-yellow-50"
                                  : controller.running_status === 2
                                  ? "text-green-600 bg-green-50"
                                  : controller.running_status === 3
                                  ? "text-red-600 bg-red-100"
                                  : controller.running_status === 4
                                  ? "text-red-600 bg-red-100"
                                  : ""
                              }`}
                            >
                              <FaRegDotCircle />
                              {controller.running_status === 1
                                ? "Listed"
                                : controller.running_status === 2
                                ? "Activated"
                                : controller.running_status === 3
                                ? "Deactivated"
                                : controller.running_status === 4
                                ? "Activation Pending"
                                : "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {controller.actvtd_on ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins text-xl"
                            >
                              <Menu placement="left">
                                <MenuHandler>
                                  <Button className="rounded-full p-2 bg-transparent shadow-none outline-none">
                                    <MdOutlineMoreHoriz className="text-lg text-black" />
                                  </Button>
                                </MenuHandler>
                                <MenuList className="p-0 w-fit min-w-[unset] rounded-full border-0 shadow-none flex">
                                  <MenuItem
                                    className="w-fit font-poppins rounded-full"
                                    onClick={() =>
                                      handleOpenControllerUpdate(controller)
                                    }
                                  >
                                    <LuPencil className="font-bold text-lg text-[#03438D]" />
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Card>
            ) : (
              <NoDataFound />
            )}
          </div>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}

        <div className="flex items-center justify-center gap-4">
          <div className="flex items-center justify-center gap-2">
            <Pagination
              count={myControllerList.totalPages}
              defaultPage={Number(page_nmr) ?? 1}
              siblingCount={0}
              boundaryCount={1}
              onChange={(e, p) => handlePaginationChange(e, p)}
              sx={{
                fontFamily: "Poppins",
                ".MuiPaginationItem-root": {
                  fontFamily: "Poppins",
                  borderRadius: "8px",
                  color: "#BDBDBD",
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminController;
